import { useState, useEffect } from 'react';
import { Lang } from '../i18n';

interface CookieBannerProps {
    lang: Lang;
    onOpenPrivacy: () => void;
}

const translations: Record<Lang, { message: string; accept: string; learnMore: string }> = {
    fr: {
        message: 'Ce site utilise uniquement des cookies techniques essentiels (authentification, langue).',
        accept: 'Compris',
        learnMore: 'En savoir plus'
    },
    en: {
        message: 'This site uses only essential technical cookies (authentication, language).',
        accept: 'Got it',
        learnMore: 'Learn more'
    },
    es: {
        message: 'Este sitio utiliza únicamente cookies técnicas esenciales (autenticación, idioma).',
        accept: 'Entendido',
        learnMore: 'Más información'
    },
    pt: {
        message: 'Este site utiliza apenas cookies técnicos essenciais (autenticação, idioma).',
        accept: 'Entendi',
        learnMore: 'Saber mais'
    },
    de: {
        message: 'Diese Website verwendet nur technisch notwendige Cookies (Authentifizierung, Sprache).',
        accept: 'Verstanden',
        learnMore: 'Mehr erfahren'
    },
    ar: {
        message: 'يستخدم هذا الموقع ملفات تعريف الارتباط التقنية الضرورية فقط (المصادقة، اللغة).',
        accept: 'فهمت',
        learnMore: 'معرفة المزيد'
    },
    zh: {
        message: '本网站仅使用必要的技术 Cookie（身份验证、语言）。',
        accept: '知道了',
        learnMore: '了解更多'
    }
};

const CookieBanner = ({ lang, onOpenPrivacy }: CookieBannerProps) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookie-consent');
        if (!consent) {
            // Small delay for smoother UX
            const timer = setTimeout(() => setVisible(true), 500);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookie-consent', 'accepted');
        setVisible(false);
    };

    if (!visible) return null;

    const t = translations[lang] || translations.en;
    const isRtl = lang === 'ar';

    return (
        <div className={`cookie-banner ${isRtl ? 'rtl' : ''}`}>
            <div className="cookie-banner-content">
                <span className="cookie-icon">🍪</span>
                <p className="cookie-message">{t.message}</p>
                <div className="cookie-actions">
                    <button className="cookie-learn-more" onClick={onOpenPrivacy}>
                        {t.learnMore}
                    </button>
                    <button className="cookie-accept" onClick={handleAccept}>
                        {t.accept}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieBanner;
